export const breakpoints = {
  mobile: '0',
  tablet: '740px',
  desktop: '1025px',
  desktopLarge: '1281px',
  desktopXLarge: '1441px',
};

export type Breakpoints = keyof typeof breakpoints;
